// models
import { ATDLValidationRuleModel } from "./atdl-validation-rule.model";
import { ATDLValidationGroupModel } from "./atdl-validation-group.model";

export class ATDLValidationCaseModel {
  public errorMessage: string = null;
  public logicGroups: Array<ATDLValidationGroupModel> = null;
  public rules: Array<ATDLValidationRuleModel> = null;

  constructor(errorMsg?: string) {
    this.errorMessage = errorMsg;
  }
}
